import React, { Component } from 'react';
import Teams from './teams';
import authorize from '../authorization/authorize';
import AccessDeniedBehavior from '../../services/enums/accessDeniedBehavior';
import Permissions from '../../services/enums/permissions';
import PrivateRouteWrapper from '../router/privateRouteWrapper';
const AuthorizedTeams = authorize([Permissions.manageUsers, Permissions.manageTeams], AccessDeniedBehavior.displayError)(Teams);

export default class TeamsContainer extends Component {

    render() {

        return(
            <PrivateRouteWrapper>
                <AuthorizedTeams />
            </PrivateRouteWrapper>
        );
    }
}
